<template>
  <!-- 红包管理-口令红包管理 -->
  <div class="pwd_redenvelope-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" class="add-btn" @click="openAddDialog"
            >添加红包</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="openMark"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
            @change="handleRedPacketEnable"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="openMark1"
            :active-value="1"
            :inactive-value="0"
            active-text="在线抢红包打开"
            inactive-text="在线抢红包关闭"
            @change="handleGrabRedPacketEnable"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-upload
            accept=".xls,.xlsx"
            :show-file-list="false"
            :on-success="onSuccess"
            :on-error="onError"
            style="display: inline-flex; margin-right: 10px"
            :action="action"
            :headers="headers"
          >
            <el-button size="mini" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-download"
            @click="downloadExcel"
          >
            下载模版
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query_pwd.password_val"
            placeholder="请输入口令"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 140px"
            v-model="query_pwd.type"
            placeholder="请选择类型"
          >
            <el-option label="一次性失效随机红包" :value="1"></el-option>
            <el-option label="多次随机红包" :value="2"></el-option>
            <el-option label="多次固定红包" :value="3"></el-option>
            <el-option label="CDK充值红包" :value="4"></el-option>
            <el-option label="当日口令红包" :value="5"></el-option>
            <el-option label="微信公众号签到红包" :value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="getData">
            全局搜索
          </el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-time-picker
            v-model="amountForm.start_time"
            value-format="HH:mm:ss"
            placeholder="开始时间"
          >
          </el-time-picker>
          -
          <el-time-picker
            v-model="amountForm.end_time"
            value-format="HH:mm:ss"
            placeholder="结束时间"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="handleAmountControl">
            保存
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="amountForm.amountControl"
            :active-value="1"
            :inactive-value="0"
            active-text="金额控制打开"
            inactive-text="金额控制关闭"
            @change="handleAmountControl"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </header>

    <!-- body内容主体 -->
    <div class="body-box">
      <!-- 表格 -->
      <el-table v-loading="loading" :data="dataList">
        <el-table-column prop="type" label="红包类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="parseInt(row.type) === 1">一次性失效随机红包</span>
            <span v-if="parseInt(row.type) === 2">多次随机红包</span>
            <span v-if="parseInt(row.type) === 3">多次固定红包</span>
            <span v-if="parseInt(row.type) === 4">当日口令红包</span>
            <span v-if="parseInt(row.type) === 5">CDK充值红包</span>
            <span v-if="parseInt(row.type) === 6">导入红包</span>
            <span v-if="parseInt(row.type) === 8">对战开箱口令红包</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="use_num"
          label="使用次数"
          align="center"
        ></el-table-column>
        <el-table-column prop="open_time" label="开始时间" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.open_time">一次性失效随机红包</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="failure_time"
          label="失效时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="min_price"
          label="金额最低值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="max_price"
          label="金额最高值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="min_level"
          label="等级最低值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="max_level"
          label="等级最高值"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total_price"
          label="红包总额"
          align="center"
        ></el-table-column>
        <el-table-column prop="price_type" label="红包方式" align="center">
          <template slot-scope="{ row }">
            <span v-if="parseInt(row.price_type) === 1">随机金额</span>
            <span v-if="parseInt(row.price_type) === 2">固定总额</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="show_text"
          label="多次固定红包"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="350px" align="center">
          <template slot-scope="{ row }">
            <el-row>
              <el-button @click="pathToCdkey(row.id)">口令列表</el-button>
              <!-- <el-button type="danger" @click="handleDelete(row.id)"
                >删除
              </el-button> -->
            </el-row>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗-->
    <!-- 添加红包 -->
    <el-dialog
      title="添加口令详情"
      :visible.sync="addVisible"
      width="450px"
      center
    >
      <el-form
        :model="addFormData"
        label-width="120px"
        :rules="addrules"
        ref="form"
        size="small"
      >
        <el-form-item prop="type" label="红包类型">
          <el-select v-model="addFormData.type" :hide-required-asterisk="true">
            <el-option label="一次性失效随机红包" :value="1"></el-option>
            <el-option label="多次随机红包" :value="2"></el-option>
            <el-option label="多次固定红包" :value="3"></el-option>
            <el-option label="CDK充值红包" :value="5"></el-option>
            <el-option label="当日口令红包" :value="4"></el-option>
            <!-- <el-option label="对战开箱口令红包" :value="8"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="addFormData.type === 4 || addFormData.type === 5"
          prop="recharge_limit"
          label="充值金额"
        >
          <el-input
            v-model="addFormData.recharge_limit"
            placeholder="请设置金额"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="addFormData.type === 4 || addFormData.type === 7"
          prop="unpack_limit"
          :label="`${addFormData.type === 4 ? '流水金额' : '对战开箱消耗金额'}`"
        >
          <el-input
            v-model="addFormData.unpack_limit"
            placeholder="请设置金额"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="addFormData.type != 4"
          prop="failure_time"
          label="失效时间"
        >
          <el-date-picker
            v-model="addFormData.failure_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="use_num" label="使用次数">
          <el-input
            v-model="addFormData.use_num"
            placeholder="使用次数"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password_val" label="口令值">
          <el-input
            v-model="addFormData.password_val"
            placeholder="固定口令红包时口令值必填"
          ></el-input>
        </el-form-item>
        <el-form-item prop="price_type" label="红包方式">
          <el-select v-model="addFormData.price_type">
            <el-option label="随机金额" :value="1"></el-option>
            <el-option label="固定总额" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="open_time" label="开始时间">
          <el-date-picker
            v-model="addFormData.open_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="min_level" label="等级最低值">
          <el-input-number
            v-model="addFormData.min_level"
            label="等级最低值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="max_level" label="等级最高值">
          <el-input-number
            v-model="addFormData.max_level"
            label="等级最高值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="min_price" label="金额最低值">
          <el-input-number
            v-model="addFormData.min_price"
            :min="0.01"
            label="金额最低值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="max_price" label="金额最高值">
          <el-input-number
            v-model="addFormData.max_price"
            :min="1"
            label="金额最高值"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="total_price" label="红包总额">
          <el-input-number
            v-model="addFormData.total_price"
            :min="1"
            label="红包总额"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="show_text" label="展示文字">
          <el-input v-model="addFormData.show_text"></el-input>
        </el-form-item>
        <el-form-item prop="id_card_limit" label="最大关联领取数">
          <el-input
            v-model="addFormData.id_card_limit"
            placeholder="输入0不限制关联次数"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addSubmit"
          :loading="buttonLoading"
          style="margin-left: 50px"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { server, delData, getData, patchData, postData, getApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
export default {
  name: 'pwd_redenvelope',
  data() {
    return {
      buttonLoading: false,//按钮加载动画
      loading: false,//加载动画
      addVisible: false,//添加红包模态框标志
      openMark: 0,//开关标志,0是关闭，1是打开
      openMark1: 0,//在线抢开关标志,0是关闭，1是打开
      amountForm: {
        start_time: '',
        end_time: '',
        amountControl: 0,//金额控制开关标志,0是关闭，1是打开
      },
      query_pwd: {//查询表格的查询信息,默认第一页
        page: 1,
        password_val: undefined,
        type: '',//1一次性失效随机红包 2多次随机红包 3多次固定红包 4CDK充值红包 5当日口令红包 9微信公众号签到红包
      },
      addFormData: {//添加红包表单信息
        failure_time: undefined,//失效时间
        use_num: undefined,//使用次数
        min_price: undefined,
        max_price: undefined,
        type: undefined,
        recharge_limit: 0,
        unpack_limit: 0,
        show_text: undefined,
        id_card_limit: undefined,//最大关联领取数
        password_val: '',
        price_type: undefined,
        open_time: undefined,//开始时间
        min_level: undefined,//最低等级
        max_level: undefined,//最高等级
        total_price: undefined
      },
      dataList: undefined,//表格数据
      page: 1,//底部页数，默认为1
      dataMeta: undefined,//底部跳转页面条
      addrules: {//添加表单校验规则
        failure_time: [{ required: true, message: '请输入失效时间' }],
        use_num: [{ required: true, message: '请输入最多使用次数' }],
        price_type: [{ required: true, message: '请选择红包方式' }],
        show_text: [{ required: true, message: '请输入展示文字' }],
        id_card_limit: [{ required: true, message: '请输入最大关联领取数,输入0不限制关联次数' }]
      },
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}password_val_import`
    }
  },
  created() {
    this.getData();//获取表格数据
    this.getPasswordPacketConfig();//获取红包按钮状态
    this.getGrabPacketConfig();//获取在线抢红包按钮状态
    this.getAmountControl();//获取金额控制按钮状态
  },
  methods: {
    openAddDialog() {
      //打开添加口令弹窗
      this.addVisible = true
    },
    getData() {
      //拿去表格数据信息
      this.loading = true
      let params = this.query_pwd
      getData('password_packet', params)
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    addSubmit() {
      //确定添加口令红包
      //进行表单验证
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.addFormData.type != 4 && !this.addFormData.failure_time) {
            this.$message.error('失效时间不能为空')
            return
          }
          this.buttonLoading = true
          let params = this.addFormData
          postData('password_packet', params)
            .then(res => {
              this.buttonLoading = false
              this.addVisible = false
              this.$message.success('添加成功')
              this.getData()//刷新列表
            })
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    },
    getPasswordPacketConfig() {
      //获取关闭/打开红包按钮状态
      getData('password_packet_config')
        .then(res => {
          if (res.data) {
            this.openMark = 1
          }
        })
    },
    handleRedPacketEnable() {
      //关闭/打开红包按钮
      let params = { "redPacketConfig": this.openMark ? 1 : 0 }
      patchData('password_packet_config', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.openMark = !this.openMark
        })
    },
    getGrabPacketConfig() {
      //获取关闭/打开在线抢红包按钮状态
      getApiData('countdown_red_envelopes')
        .then(res => {
          if (res) {
            res.data ? this.openMark1 = 1 : this.openMark1 = 0
          }
        })
    },
    handleGrabRedPacketEnable() {
      //关闭/打开红包按钮
      let params = { "black": this.openMark1 ? 1 : 0 }
      patchApiData('countdown_red_envelopes', params)
        .then(res => {
          this.$message.success('操作成功！')
        }).catch(err => {
          //关闭/打开在线抢红包按钮失败，还原标志
          this.openMark1 = !this.openMark1
        })
    },
    getAmountControl() {
      //获取关闭/打开金额控制按钮状态
      getApiData('red_amount_limit_enable')
        .then(res => {
          if (res) {
            res.data ? this.amountForm.amountControl = 1 : this.amountForm.amountControl = 0
            this.amountForm.start_time = res.start_time
            this.amountForm.end_time = res.end_time
          }
        })
    },
    handleAmountControl() {
      //关闭/打开金额控制按钮
      if (!this.amountForm.start_time || !this.amountForm.end_time) {
        this.$message.warning('请先选择现在开始时间和结束时间')
        this.amountForm.amountControl = this.amountForm.amountControl ? 0 : 1
        return
      }
      let params = { "black": this.amountForm.amountControl ? 1 : 0, start_time: this.amountForm.start_time, end_time: this.amountForm.end_time }
      patchApiData('red_amount_limit_enable', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getAmountControl()//刷新数据
        }).catch(err => {
          //关闭/打开在线抢红包按钮失败，还原标志
          this.amountForm.amountControl = this.amountForm.amountControl ? 0 : 1
        })
    },
    pathToCdkey(id) {
      //口令列表
      let routeData = this.$router.resolve({ path: `/password_packets/${id}` })
      window.open(routeData.href, '_blank')
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      window.open('./excel/red_packet.xlsx', '_blank')
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query_pwd.page = page
      this.getData();
    },
  },
}
</script>
<style lang="less" scoped>
.pwd_redenvelope-box {
  header {
    margin-bottom: 10px;

    .el-row {
      display: flex;
      align-items: center;
    }

    .add-btn {
      margin-right: 30px;
    }
  }

  .body-box {
    //底部分页导航条
    .underBar {
      margin-top: 20px;
    }
  }
}
</style>